<template>
    <div class="col-12 align-self-center">
        <div class="card">
            <div class="card-body p-sm-3 p-md-5">
                <h2 v-if="$state.mediaError === 'NotAllowedError'">{{$t('help_access_required')}}</h2>
                <h2 v-if="$state.mediaError === 'NotFoundError'">{{$t('help_no_device')}}</h2>
                <p v-if="browser.name !== 'ios' && $state.mediaError === 'MediaRecorder not available.'">{{$t('help_no_access')}}</p>
                <template v-if="browser">
                    <template v-if="browser.name === 'firefox'">
                        <p>{{$t('help_current')}}<b>Mozilla Firefox</b>.</p>
                        <p v-html="$t('help_firefox')"></p>
                    </template>
                    <template v-else-if="browser.name === 'chrome' && !$md.mobile()">
                        <p>{{$t('help_current')}}<b>Google Chrome</b>.</p>
                        <p v-html="$t('help_chrome')"></p>
                        <img class="mw-100" v-bind:src="'/img/chrome_' + lang + '.png'">
                    </template>
                    <template v-else-if="browser.name === 'chrome' && $md.mobile()">
                        <p>{{$t('help_current')}}<b>Google Chrome (Android)</b>.</p>
                        <p v-html="$t('help_chrome')"></p>
                        <img class="mw-100" src="/img/chrome_mobile.png">
                    </template>
                    <template v-else-if="browser.name === 'safari'">
                        <p>{{$t('help_current')}}<b>Safari (Mac OS)</b>.</p>
                        <p v-html="$t('help_safari')"></p>
                    </template>
                    <template v-else-if="browser.name === 'ios'">
                        <p>{{$t('help_current')}}<b>Safari (iOS)</b>.</p>
                        <p v-html="$t('help_ios_safari')"></p>
                        <img class="mw-100" src="/img/safari_ios.png">
                    </template>
                    <template v-else-if="browser.name === 'samsung'">
                        <p>{{$t('help_current')}}<b>Samsung Browser</b>.</p>
                        <p v-html="$t('help_samsung')"></p>
                    </template>
                    <template v-else>
                        <p>{{$t('help_not_supported')}}</p>
                    </template>
                </template>
                <hr />
                <button @click="refreshPage" class="btn btn-outline-secondary mb-2"><i
                        class="fa fa-video-camera"></i> {{$t('help_try_again')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { detect } from 'detect-browser';

    export default {
        data() {
            return {
                browser: detect()
            }
        },
        computed: {
            lang() {
                return this.$state.login_info.taal === "1" ? 'nl' : 'en';
            }
        },
        methods: {
            refreshPage() {
                window.location.href = '/';
            }
        }
    }
</script>
